<template>
  <div class="card">
    <h2>Mi perfil</h2>
    <div v-if="me">
      <p><strong>Usuario:</strong> {{ me.username }}</p>
      <p v-if="me.displayName"><strong>Nombre visible:</strong> {{ me.displayName }}</p>
      <p><strong>Juegos seleccionados:</strong> {{ me.games && me.games.length ? me.games.join(', ') : 'Ninguno' }}</p>
    </div>

    <h3>Mis estadísticas</h3>
    <div class="row">
      <div class="col">
        <label>Juego</label>
        <select class="input" v-model="game">
          <option value="">Todos</option>
          <option v-for="g in games" :key="g.code" :value="g.code">{{ g.name }} ({{ g.code }})</option>
        </select>
      </div>
      <div class="col">
        <label>Desde</label>
        <input class="input" type="date" v-model="from">
      </div>
      <div class="col">
        <label>Hasta</label>
        <input class="input" type="date" v-model="to">
      </div>
      <div class="col" style="align-self:flex-end;">
        <button class="btn" @click="loadStats">Actualizar</button>
      </div>
    </div>

    <div v-if="stats" style="margin-top:10px;">
      <div class="row">
        <div class="col"><div class="card"><strong>Torneos jugados:</strong> {{ stats.totals.tournamentsPlayed }}</div></div>
        <div class="col"><div class="card"><strong>Torneos ganados:</strong> {{ stats.totals.tournamentsWon }}</div></div>
        <div class="col"><div class="card"><strong>Puntos totales:</strong> {{ stats.totals.totalMatchPoints }}</div></div>
        <div class="col"><div class="card"><strong>Mejor puesto:</strong> {{ stats.totals.bestRank || '-' }}</div></div>
        <div class="col"><div class="card"><strong>Puesto medio:</strong> {{ stats.totals.avgRank || '-' }}</div></div>
      </div>

      <div class="card">
        <h4>Resultados recientes</h4>
        <table class="table">
          <thead><tr><th>Fecha</th><th>Torneo</th><th>Juego</th><th>Rank</th><th>Puntos</th></tr></thead>
          <tbody>
          <tr v-for="r in stats.recent" :key="r.tournamentId + '-' + r.rank">
            <td>{{ formatDate(r.eventDate) }}</td>
            <td>{{ r.title }}</td>
            <td>{{ r.game }}</td>
            <td>{{ r.rank }}</td>
            <td>{{ r.winPoints }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h3>Seleccionar juegos</h3>
    <div class="row">
      <label v-for="g in games" :key="g.code" style="display:inline-flex;align-items:center;margin-right:16px;">
        <input type="checkbox" :value="g.code" v-model="selected">
        <span style="margin-left:6px;">{{ g.name }} ({{ g.code }})</span>
      </label>
    </div>
    <div style="margin-top:10px;">
      <button class="btn" @click="save" :disabled="saving">{{ saving ? 'Guardando...' : 'Guardar' }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from "@/services/api";
export default {
  data: () => ({
    selected: [],
    saving: false,
    stats: null,
    game: '',
    from: '',
    to: ''

  }),
  computed: {
    ...mapGetters(['me', 'games'])
  },
  async created() {
    await this.$store.dispatch('fetchMe');
    await this.$store.dispatch('listGames');
    this.selected = (this.me && this.me.games) ? [...this.me.games] : [];
  },
  methods: {
    ...mapActions(['saveMyGames']),
    async save() {
      this.saving = true;
      try {
        await this.saveMyGames(this.selected);
        await this.$store.dispatch('fetchMe');
      } finally {
        this.saving = false;
      }
    },
    async loadStats() {
      const params = {};
      if (this.game) params.game = this.game;
      if (this.from) params.from = this.from;
      if (this.to) params.to = this.to;
      const { data } = await api.get('/api/me/stats', { params });
      this.stats = data;
    },
    formatDate(d) { return new Date(d).toLocaleDateString(); }
  }
}
</script>
